export const getTotalRecords = (response) => {
    if (typeof response?.data?.total === 'number') return response.data.total;
    if (typeof response?.recordsTotal === 'number') return response.recordsTotal;
    if (typeof response?.total === 'number') return response.total;
    if (typeof response?.pagination?.total === 'number') return response.pagination.total;
    return undefined;
};

export const getRows = (response) => {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data?.data)) return response.data.data;
    if (Array.isArray(response?.data)) return response.data;
    return [];
};